import Utils from "@/utils/Default/Utils";
import {useEffect, useState} from "react";

const PreFilterItem = ({applied, index, prepareLabelBloc, applyFilters, action, filter}) => {
    const [isActive, setIsActive] = useState(false)
    useEffect(() => {
        if (applied !== isActive) {
            setIsActive(applied)
        }
    }, [applied])
    return (<li key={index}><a
        className={isActive ? 'dp__header__pre-filter__filter--applied' : 'dp__header__pre-filter__filter'}
        onClick={(event) => {
            event.preventDefault();
            setIsActive(!isActive);
            appData.actionTrigger.dispatch({
                trigger: "preFilterClicked",
                payload: {
                    prefilterName: filter[1]
                }
            });
            applyFilters(event, filter, action)
        }}
        href={Utils.getMetaInfosValueByCode("seoUrl", filter[6])}>{prepareLabelBloc(filter[1])}</a>
    </li>)
}

export default PreFilterItem